import * as React from "react";
import { useEffect, useState, useMemo } from "react";
import { useAuth } from "../../hooks/useAuth";
import { isFacebookSDKInitialized } from "../../utils/facebook";
import { useGetConnectionsQuery } from "../../services/connections";
import { columnHelper } from "../../utils/utils";
import { generateDynamicColumns } from "../../utils/generateDynamicColumns";
import TableTemplate from "../../components/common/TableTemplate";
import LoadingState from "../../components/states/LoadingState";
import ErrorState from "../../components/states/ErrorState";

const ConnexionsPage = () => {
  const { userData } = useAuth();
  const [isSDKReady, setIsSDKReady] = useState(false);

  const { data: connections, isLoading, error } = useGetConnectionsQuery();
  console.log("connections: ", connections);

  useEffect(() => {
    // Check if SDK is already initialized
    if (isFacebookSDKInitialized()) {
      setIsSDKReady(true);
      return;
    }

    // If not, wait for fbAsyncInit
    const checkSDK = setInterval(() => {
      if (isFacebookSDKInitialized()) {
        setIsSDKReady(true);
        clearInterval(checkSDK);
      }
    }, 100);

    // Cleanup
    return () => clearInterval(checkSDK);
  }, []);

  const handleFacebookLogin = () => {
    if (!isSDKReady) {
      console.error("Facebook SDK not ready");
      return;
    }

    // Create state data object
    const stateData = {
      user_id: userData.userGlid,
    };

    // Convert to base64
    const encodedState = btoa(JSON.stringify(stateData));

    // Your app ID from Facebook Developer Console
    const appId = "1265886208841694"; // Replace with your actual app ID

    // Backend URL that will handle the OAuth response
    const redirectUri =
      `${import.meta.env.VITE_BASE_SERVER_URL}api/auth/facebook/callback`;

    // Using the manual flow as described in the Facebook documentation
    const dialogUrl = window.FB.getLoginStatus(function (response) {
      // Construct the dialog URL manually
      const baseUrl = "https://www.facebook.com/v22.0/dialog/oauth";
      const params = new URLSearchParams({
        client_id: appId,
        redirect_uri: redirectUri,
        state: encodedState,
        response_type: "code", // Request an authorization code
        config_id: "1486096452775422",
        auth_type: "rerequest",
      });

      // Redirect to the Facebook OAuth dialog
      window.location.href = `${baseUrl}?${params.toString()}`;
    });
  };

  const columns = useMemo(
    () =>
      generateDynamicColumns({
        columnHelper,
        headerData: connections?.[0]?.Column_header,
      }),
    [connections]
  );

  if (isLoading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState error={error} />;
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Connexions</h1>

      <button
        className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        onClick={handleFacebookLogin}
        disabled={!isSDKReady}
      >
        {!isSDKReady ? "Loading Facebook..." : "+ Add Connexion"}
      </button>
      <TableTemplate columns={columns} data={connections[0]?.data} />
    </div>
  );
};

export default ConnexionsPage;
